import React from "react";
import ReactToPrint from "react-to-print";
import ButtonLinkIcon from "../MyComponent/ButtonLinkIcon";
import DownLoadIcon from "../../svg/svgicon/DownLoadIcon";
import ComponentToPrint from "./ComponentToPrint";
class PrintComponent extends React.Component {
  render() {
    return (
      <div>
        <div>
          <ReactToPrint
            trigger={() => (
              <ButtonLinkIcon
                icon={<DownLoadIcon />}
                name={this.props.buttonText}
              />
            )}
            content={() => this.componentRef}
          />
        </div>
        <div style={{ display: "none" }}>
          <ComponentToPrint
            content={this.props.content}
            ref={(el) => (this.componentRef = el)}
          />
        </div>
      </div>
    );
  }
}

export default PrintComponent;
